module.exports = __webpack_public_path__ + "img/Symbol_3.a279d00f.png";